import {
  Autocomplete,
  Box,
  Grid,
  IconButton,
  InputLabel,
  Link,
  Skeleton,
  TextField,
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import DeleteIcon from '@mui/icons-material/Delete';
import { LoadingButton } from '@mui/lab';
import React, { memo, useState } from 'react';
import ApiService from '../../../services/ApiService';
import SimpleMDE from 'react-simplemde-editor';
import 'easymde/dist/easymde.min.css';
import ListRekomendasi from './ListRekomendasi';

const AnalisaPenyebab = ({
  input,
  setInput,
  loading,
  setSnackbar,
  readOnly = false,
}) => {
  const [loadingUpload, setLoadingUpload] = useState(false);

  const onUploadFile = async (e) => {
    try {
      setLoadingUpload(true);
      const files = e.target.files[0];
      if (files.size > 1024 * 1024 * 10) throw 'Ukuran file maximum 10 Mb.';

      const fd = new FormData();
      fd.append('file', files);
      const resUpload = await ApiService.postUploadDocument('LI', fd);
      if (!resUpload.data.isOk) throw resUpload.data.message;
      const newList = [...input.uploadDocumentList, resUpload.data.payload[0]];
      setInput((prev) => ({ ...prev, uploadDocumentList: newList }));
      setLoadingUpload(false);
    } catch (error) {
      setSnackbar({
        isOpen: true,
        type: 'warning',
        message: error.message || error,
      });
      setLoadingUpload(false);
    }
  };

  const onRemoveFile = (id) => {
    const newList = input.uploadDocumentList.filter((o) => o.id != id);
    setInput((prev) => ({ ...prev, uploadDocumentList: newList }));
  };

  if (loading) {
    return (
      <Box sx={styles.container}>
        <h3
          style={{
            color: 'black',
            textAlign: 'center',
          }}
        >
          ANALISA PENYEBAB
        </h3>
        <Grid container gap={1}>
          <Grid container item gap={2}>
            <Grid item xl={12} lg={12} sm={12} xs={12}>
              <Skeleton variant="text" sx={{ fontSize: '2.5rem' }} />
            </Grid>
            <Grid item xl={12} lg={12} sm={12} xs={12}>
              <Skeleton variant="text" sx={{ fontSize: '2.5rem' }} />
            </Grid>
            <Grid item xl={12} lg={12} sm={12} xs={12}>
              <Skeleton variant="text" sx={{ fontSize: '2.5rem' }} />
            </Grid>
            <Grid item xl={12} lg={12} sm={12} xs={12}>
              <Skeleton variant="text" sx={{ fontSize: '2.5rem' }} />
            </Grid>
            <Grid item xl={12} lg={12} sm={12} xs={12}>
              <Skeleton variant="text" sx={{ fontSize: '2.5rem' }} />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    );
  }

  return (
    <>
      <Box sx={styles.container}>
        <h3
          style={{
            color: 'black',
            textAlign: 'center',
          }}
        >
          ANALISA PENYEBAB
        </h3>
        <Grid container gap={1}>
          <Grid container item gap={2}>
            <Grid item xl={12} lg={12} sm={12} xs={12}>
              <Autocomplete
                options={input.listClsrCategory}
                getOptionLabel={(option) => option?.name || ''}
                renderInput={(params) => (
                  <TextField {...params} label="Kategori CLSR" />
                )}
                isOptionEqualToValue={(o, v) =>
                  o.id && v.id ? o.id == v.id : false
                }
                value={{
                  id: input.idTbldataMstClsrCategory,
                  name: input.clsrCategoryName,
                }}
                onChange={(e, value) => {
                  setInput((prev) => ({
                    ...prev,
                    clsrCategoryName: value.name,
                    idTbldataMstClsrCategory: value.id,
                  }));
                }}
                disabled={readOnly}
              />
            </Grid>
            <Grid item xl={12} lg={12} sm={12} xs={12}>
              {/* <InputLabel shrink={true}>Penyebab Langsung</InputLabel> */}
              <left>
                <h4>Penyebab Langsung</h4>
              </left>
              <SimpleMDE
                value={input.penyebabLangsung}
                // options={{
                //   spellChecker: false,
                //   hideIcons: [
                //     "link",
                //     "image",
                //     "preview",
                //     "fullscreen",
                //     "guide",
                //     "side-by-side",
                //   ],
                // }}
                onChange={(value) => {
                  setInput({
                    ...input,
                    penyebabLangsung: value,
                  });
                }}
              />
            </Grid>
            <Grid item xl={12} lg={12} sm={12} xs={12}>
              {/* <InputLabel shrink={true}>Penyebab Dasar</InputLabel> */}
              <left>
                <h4>Penyebab Dasar</h4>
              </left>
              <SimpleMDE
                value={input.penyebabDasar}
                // options={{
                //   spellChecker: false,
                //   hideIcons: [
                //     "link",
                //     "image",
                //     "preview",
                //     "fullscreen",
                //     "guide",
                //     "side-by-side",
                //   ],
                // }}
                onChange={(value) => {
                  setInput({
                    ...input,
                    penyebabDasar: value,
                  });
                }}
              />
            </Grid>

            <ListRekomendasi
              input={input}
              setInput={setInput}
              loading={loading.fetch}
              setSnackbar={setSnackbar}
              readOnly={readOnly}
            />
            <br />

            <Grid item xl={12} lg={12} sm={12} xs={12}>
              <Box component="div" sx={styles.field}>
                <LoadingButton
                  variant="contained"
                  component="label"
                  loading={loadingUpload}
                  startIcon={<SendIcon />}
                  loadingPosition="start"
                  disabled={readOnly}
                >
                  Upload Document
                  <input
                    hidden
                    multiple
                    accept=".pdf,.png,.jpg"
                    type="file"
                    onChange={onUploadFile}
                  />
                </LoadingButton>
                <span style={{ color: 'red', marginLeft: '20px' }}>
                  <small>
                    * Format file upload yang diterima (.pdf, .jpg) (Maximum 10
                    Mb)
                  </small>
                </span>
                {input.uploadDocumentList.map((doc, idx) => (
                  <div key={idx}>
                    <span>{idx + 1}. </span>
                    <a
                      href="#"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={async (e) =>
                        await ApiService.viewFile(doc.url, e)
                      }
                    >
                      {doc.fileName}
                    </a>
                    <IconButton
                      aria-label="delete"
                      color="error"
                      onClick={() => onRemoveFile(doc.id)}
                      disabled={readOnly}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </div>
                ))}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

const styles = {
  container: {
    px: 5,
    mt: 3,
    pt: 1,
    pb: 5,
    borderRadius: 3,
    display: 'block',
    backgroundColor: '#fff',
  },
  field: {
    border: 1,
    borderColor: 'lightgrey',
    px: 3,
    py: 2,
    borderRadius: 2,
    display: 'block',
    backgroundColor: '#fff',
  },
};
export default memo(AnalisaPenyebab);
